
import "./AllClients.css";
import { radioType } from "../../interfaces";
import ReactModal from "react-modal";
import React from "react";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

type propsType = {
    openReason: boolean
    setOpenReason: React.Dispatch<React.SetStateAction<boolean>>
    reasonsType: radioType[]
    setReasonsType: React.Dispatch<React.SetStateAction<radioType[]>>
    setOpenCancel: React.Dispatch<React.SetStateAction<boolean>>
    otherType: string
    setOtherType: React.Dispatch<React.SetStateAction<string>>
}

function ReasonForCancel({ openReason, setOpenReason, reasonsType, setReasonsType, setOpenCancel, otherType, setOtherType }: propsType) {

    const [openSelectWindow, setOpenSelectWindow] = React.useState<boolean>(false);

    const closeWindow = (): void => {
        setOtherType('');
        setOpenReason(false);
    }

    const findActivePhoneNumber = (): string => {
        const activeTtpe: radioType | undefined = reasonsType.find(type => type.active);
        if (activeTtpe) {
            return activeTtpe.title;
        }
        else {
            return "";
        }
    }

    const onOptionClicked = (item: radioType): void => {
        setReasonsType((reasons: radioType[]) => reasons.map(type => type.id === item.id ? { ...type, active: true } : { ...type, active: false }));
        setOpenSelectWindow(false);
    }

    const goToCancelWindow = (): void => {
        setOpenReason(false);
        setOpenCancel(true);
    }

    return(
        <ReactModal
            isOpen = { openReason }
            onRequestClose = { () => closeWindow() }
            style = {{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.2)',
                    zIndex: 300,
                },
                content: {
                    width: "80%",
                    maxWidth: '550px',
                    maxHeight: "350px",
                    height: "auto",
                    border: 'none',
                    margin: "auto",
                    borderRadius: "10px",
                    background: 'white',
                    WebkitOverflowScrolling: 'touch',
                    outline: 'none',
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: 'column',
                    alignItems: "center",
                    justifyContent: "flex-start",
                }
            }}
        >
            <div
                className = "modal-deleteClient-closing"
                style = {{ cursor: 'pointer' }}
                aria-label = "close"
            >
                <CloseRoundedIcon
                    onClick = { closeWindow }
                />
            </div>
            <div className='modal-deleteClient-content'>
                Reason Cancelation
            </div>
            <div
                className = 'modal-reason-main-box'
                style = {{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%"
                }}
            >
                <div
                    className = "phoneNumber-box-dropdown-container"
                    style = {{
                        margin: "10px 0"
                    }}
                >
                    <div
                        className = "phoneNumber-box-dropdown-header"
                        onClick = { () => setOpenSelectWindow(!openSelectWindow) }
                        style = {{
                            fontSize: "13px"
                        }}
                    >
                        { findActivePhoneNumber() }
                        <ArrowDropDownIcon className = "phoneNumber-box-dropdown-header-arrow"/>
                    </div>
                    {
                        openSelectWindow && (
                            <ul className = "phoneNumber-box-dropdown-list reason-type-list">
                                {
                                    reasonsType.map((type: radioType) =>
                                        <li
                                            key = { type.id }
                                            className = "phoneNumber-box-dropdown-li"
                                            onClick = {() => onOptionClicked(type)}
                                        >
                                            { type.title }
                                        </li>
                                    )
                                }
                            </ul>
                        )
                    }
                </div>
            </div>
            {
                findActivePhoneNumber() === 'Other' ?
                    <input
                        type = 'text'
                        value = { otherType }
                        onChange = { (e) => setOtherType(e.target.value) }
                        className = 'reason-input-for-other'
                        autoFocus = { findActivePhoneNumber() === 'Other' }
                    />
                    :
                    null
            }
            <button
                className = "reason-submit-button"
                onClick = { goToCancelWindow }
            >
                Submit
            </button>
        </ReactModal>
    )
}

export default ReasonForCancel
